import { Radio } from "@mui/material";
import { styled } from "@mui/styles";

const CustomRadio = styled(Radio)(({ theme }) => ({
    color: "#e0e0e0",
    paddingBlock: "0 !important"
    ,
    "&.Mui-checked": {
        color: `${theme.palette.customColors.checkboxcolor} !important` ,
    },
    "& .MuiSvgIcon-root": {
        borderRadius: "50%",
    },
}));
export default CustomRadio